module.exports = __webpack_public_path__ + "img/snow_fall_00027.7f9ccaca.png";